import { Point, Ticker } from 'pixi.js'
import input from '../input'
import Layer from './index'
import LayerBase from './LayerBase'

export function startParallax(layers: Layer[], bulletLayers: LayerBase[]): void {
  const ticker = new Ticker()
  ticker.start()

  const ratio = new Point()
  ticker.add(() => {
    const current = input.getRatio()
    ratio.copyFrom(current)

    for (const layer of layers) layer.setPosition(ratio)
    // for (const bullet of bulletLayers) bullet.setPosition(ratio)
  })
}
